import axios, { AxiosRequestConfig } from 'axios';
import { useEffect, useState } from 'react';

const useAxiosWLS = <TResponse = any, TBody = any, TError = any>({url, options}:{url?: string, options?: AxiosRequestConfig<any>}): {data: TResponse|undefined, error: Error | undefined, loading: boolean, refetch: Function} =>{
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const refetch = async () => {
    if (!url) return;

    setLoading(true);
    try {
      const response = await axios.get<TResponse>(url, options);
      setData(response.data);
      setError(null);
    } catch (err) {
      setError(err as TError);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!url) return;

    setLoading(true);
    
    refetch()
  }, [url]);

  return { data, error, loading, refetch };
}

export default useAxiosWLS